export default function (http) {
    return {


        queryByPage(data) {
            return http.json({
                url: `/pay/order/detail/queryByPage?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        queryFundByPage(data) {
            return http.json({
                url: `/pay/order/refund/queryByPage?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },


        getDetailInfo(data) {
            return http.json({
                url: `/pay/order/detail/getDetailInfo?id=${data.id}`,
                data
            })
        },

        getRefundInfo(data) {
            return http.json({
                url: `/pay/order/refund/getRefundInfo?id=${data.id}`,
                data
            })
        },

        getRefund(data) {
            return http.json({
                url: `/pay/order/refund/get?id=${data.id}`,
                data
            })
        },

        queryAll(data) {
            return http.json({
                url: `/pay/order/detail/queryAll`,
                data
            })
        },
        saveInfo(data) {
            return http.json({
                url: `/pay/order/detail/save`,
                data
            })
        },
        getOne(data) {
            return http.json({
                url: `/pay/order/detail/getOne`,
                data
            })
        },


        delete(data) {
            return http.json({
                url: `/pay/order/detail/deleteOrder`,
                data
            })
        },

        updateState(data) {
            return http.json({
                url: `/pay/order/detail/updateState`,
                data
            })
        },


        updateSuggested(data) {
            return http.json({
                url: `/pay/order/detail/updateSuggested`,
                data
            })
        },

        applyPass(data) {
            return http.json({
                url: `/pay/order/detail/applyPass`,
                data
            })
        },


        pass(data) {
            return http.json({
                url: `/refund/out?id=`+data.id,
                data
            })
        },

        fail(data) {
            return http.json({
                url: `/pay/order/applyRefuse`,
                data
            })
        },

        logistics(data) {
            return http.json({
                url: `/pay/order/logistics`,
                data
            })
        },

        queryWuliu(data) {
            return http.json({
                url: `/order/base/queryWuliu`,
                data
            })
        },


    }
}





// WEBPACK FOOTER //
// ./src/configure/http/api/order.js